import WindmillAnimation from "../lottie/windmill.json";
import FlowerAnimation from "../lottie/flower.json";
import TreeAnimation from "../lottie/tree.json";
import DearAnimation from "../lottie/dear.json";
import WaterfallAnimation from "../lottie/waterfall.json";
import FishAnimation from "../lottie/fish.json";
import Tree2Animation from "../lottie/tree2.json";
import HenAnimation from "../lottie/hen.json";

export const stages = [
  {
    x: 40,
    y: 420,
    task: "إرسال رسالة تحية وسلام لأحد الأقارب البعيدين",
    task_en: "Send a greeting message to a distant relative",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 120,
    y: 260,
    task: "مكالمة هاتفية مع الجد أو الجدة وتسجيل رسالة صوتية منهم",
    task_en:
      "Phone call with grandfather/grandmother and share verballying their confirmation message",
    verificationNeed: 1,
    requiredRoles: ["father"],
  },
  {
    x: 250,
    y: 140,
    task: "مقابلة شخصية مع أحد الأقارب وأخذ سيلفي معه",
    task_en: "In-person meeting with a relative and taking a selfie together",
    verificationNeed: 1,
    requiredRoles: ["father"],
  },
  {
    x: 295,
    y: 320,
    task: "دعوة أحد الأخوال أو العمات أو الأعمام لوجبة طعام",
    task_en: "Invite an aunt/uncle to a meal",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 430,
    y: 450,
    task: "إهداء شيء بسيط (زهور، مأكولات أو كتاب) لأحد الأقارب",
    task_en: "Gift a simple item (flowers, food or book) to a relative",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 470,
    y: 220,
    task: "تسجيل وإرسال فيديو قصير عن ذكرى مضحكة عائلية",
    task_en: "Record a short confirmation about a funny family memory",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 630,
    y: 170,
    task: "المشاركة في مناسبة عائلية أو اجتماع وإرسال تقرير مصور",
    task_en: "Attend a family gathering confirmation report",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 680,
    y: 430,
    task: "دعوة أحد الأقارب للتسجيل في SambiteQuest",
    task_en: "Invite a relative to register in SambiteQuest",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 850,
    y: 350,
    task: "إرسال رسالة محبة للأخ، الأخت أو ابن/ابنة العم/الخال",
    task_en: "Send a loving message to sibling or cousin",
    verificationNeed: 1,
    requiredRoles: ["sibling"],
  },
  {
    x: 1020,
    y: 230,
    task: "اقتراح إنشاء مجموعة عائلية افتراضية في تطبيق مراسلة",
    task_en: "Suggest creating a virtual family group in messaging app",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 1160,
    y: 250,
    task: "مشاهدة فيلم عائلي قديم مع الوالدين وتسجيل دقيقة من تلك اللحظة",
    task_en:
      "Watch old family movie with parents and share verbally 1 minute of that moment",
    verificationNeed: 1,
    requiredRoles: ["father"],
  },
  {
    x: 1190,
    y: 460,
    task: "رحلة يومية مع أفراد العائلة إلى مكان قريب",
    task_en: "Day trip with family members to a nearby place",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 1320,
    y: 550,
    task: "كتابة نص قصير عن إحدى الصفات الجميلة في العائلة",
    task_en: "Write a short text about a beautiful family trait",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 1360,
    y: 340,
    task: "شراء وجبة عائلية من Sambite وإرسالها لأحد الأقارب",
    task_en: "Buy family meal from Sambite and send it to a relative",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 1450,
    y: 180,
    task: "تشجيع أحد المراهقين في العائلة على عمل خيري (مع توثيق)",
    task_en: "Encourage a teenage relative to do charity (with documentation)",
    verificationNeed: 1,
    requiredRoles: ["sibling"],
  },
  {
    x: 1535,
    y: 320,
    task: "إنشاء شجرة عائلية بسيطة على الورق أو تطبيق رقمي",
    task_en: "Create a simple family tree on paper or digital app",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 1560,
    y: 490,
    task: "طلب دعاء من أحد كبار العائلة",
    task_en: "Request a blessing from a family elder",
    verificationNeed: 1,
    requiredRoles: ["father"],
  },
  {
    x: 1680,
    y: 500,
    task: "نشر نصيحة أخلاقية من أحد الكبار في التطبيق",
    task_en: "Publish an ethical advice from an elder in the app",
    verificationNeed: 1,
    requiredRoles: ["father"],
  },
  {
    x: 1705,
    y: 350,
    task: "تسجيل رسالة مشتركة من عدة أفراد للعائلة عن السلام، اللطف أو الصحة",
    task_en:
      "Record a joint message from family members about peace, kindness or health",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
  {
    x: 1800,
    y: 240,
    task: "اجتماع عائلي خاص بسم بایت: دعوة 3 أفراد لعائلة لأكل فلافل أو مشروب Sambite",
    task_en:
      "Special Sambite family gathering: Invite 3 relatives for falafel or Sambite drink",
    verificationNeed: 1,
    requiredRoles: ["friend"],
  },
];

export const animationData = [
  { x: 130, y: 250, data: WindmillAnimation, width: 190, type: "lottie" },
  { x: 50, y: 210, data: FlowerAnimation, width: 90, type: "lottie" },
  { x: -10, y: 250, data: FlowerAnimation, width: 90, type: "lottie" },
  { x: 30, y: 290, data: FlowerAnimation, width: 90, type: "lottie" },
  { x: 200, y: 80, data: TreeAnimation, width: 400, type: "lottie" },
  { x: 440, y: 190, data: DearAnimation, width: 320, type: "lottie" },
  // { x: 720, y: 70, data: FarmAnimation, width: 280, type: "lottie" },
  { x: 870, y: 250, data: WaterfallAnimation, width: 360, type: "lottie" },
  { x: 700, y: 30, data: "/farm2.png", width: 300, type: "img" },
  { x: 1225, y: 250, data: FishAnimation, width: 150, type: "lottie" },
  { x: 1430, y: 320, data: "/rock.png", width: 110, type: "img" },
  { x: 1390, y: 390, data: "/rock2.png", width: 180, type: "img" },
  { x: 1240, y: 370, data: FishAnimation, width: 120, type: "lottie" },
  { x: 1550, y: 180, data: Tree2Animation, width: 200, type: "lottie" },
  { x: 1770, y: 380, data: HenAnimation, width: 115, type: "lottie" },
];

export const mapImage = "/foodymap.png";

export default { stages, animationData, mapImage };
